import { Injectable, inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { NewsletterFormData } from '../models/newsletter-form-data';
import { NewsletterApiService } from '../api/services/newsletter-api.service';
import { NewsletterSubscribeRequest } from '../api/requests/newsletter-subscribe.request';
import { ToastService } from '@web/shared/ui';
import { HttpErrorService } from '@web/common';

@Injectable({
  providedIn: 'root',
})
export class NewsletterDataSourceService {
  private readonly newsletterApi = inject(NewsletterApiService);
  private readonly toast = inject(ToastService);
  private readonly httpError = inject(HttpErrorService);

  public subscribeByFormData(data: NewsletterFormData): Observable<void> {
    return this.newsletterApi
      .subscribe(
        new NewsletterSubscribeRequest({
          email: data.email,
        }),
      )
      .pipe(
        tap({
          next: () => {
            this.toast.show((builder) =>
              builder
                .initSuccess('Pomyślnie udało Ci się zapisać do newslettera.')
                .build(),
            );
          },
          error: (response) =>
            this.toast.show((builder) =>
              builder
                .initError(this.httpError.extract(response).multiLineMessages())
                .build(),
            ),
        }),
      );
  }
}
